import React, { Component } from 'react'
import styled from 'styled-components'
import theme from 'ui/styles/theme'
import { media } from 'styled-bootstrap-grid'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import IconDownload from 'ui/components/generic/IconDownload'
import easing from 'ui/styles/easing'

const Alternating = styled.div`
  > a:nth-child(odd) {
    background: ${theme.colors.tones.lighter};
  }
`

const Result = styled.a`
  display: block;
  text-decoration: none;
  color: inherit;
  padding: 20px 0;
  width: 100%;
  transition: background-color 0.3s ${easing.easeOutCubic};

  p {
    transition: color 0.3s ${easing.easeOutCubic};
  }

  .anim-stroke {
    transition: stroke 0.3s ${easing.easeOutCubic};
  }

  .anim-fill {
    transition: fill 0.3s ${easing.easeOutCubic};
  }

  &:hover {
    background-color: ${theme.colors.primary} !important;

    p {
      color: white;
    }

    .anim-stroke {
      stroke: white;
    }

    .anim-fill {
      fill: white;
    }
  }
`

const Text = styled.p`
  font-size: 14px;
  color: ${theme.colors.tones.dark};
  width: 100%;
  margin-bottom: 0.25em;

  ${media.sm`
    margin: 0;
  `}
`

const Header = styled(Row)`
  font-weight: 500;
  display: none;
  padding: 20px 0;
  text-transform: uppercase;
  margin-top: 20px;

  ${media.sm`
    display: flex;
  `}
`

const HeaderCol = styled(Col)`
  p {
    border-top: 1px solid ${theme.colors.tones.dark};
    width: 100%;
    padding: 20px 0 40px;
  }
`

const Title = styled(Text)`
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0.5em;
  
  ${media.sm`
    width: 55%;
    font-weight: 400;
    font-size: 12px;
  `}
`

const Heading = styled.h2`
  font-size: 20px;
  text-transform: uppercase;
  margin-bottom: 40px;
`

export default class DocumentList extends Component {
  returnString(needle, haystack) {
    if(haystack) {
      return haystack.find(straw => straw.slug === needle).title
    } else {
      return needle
    }
  }
  
  render() {
    const {
      documents,
      documentTypes,
      languages,
      heading
    } = this.props
    
    return (
      <Container fluid>
        <Heading>{heading}</Heading>
        <Header>
          <HeaderCol sm={4}>
            <Title>Title</Title>
          </HeaderCol>
          <HeaderCol sm={4}>
            <Text>Type</Text>
          </HeaderCol>
          <HeaderCol sm={2}>
            <Text>Language</Text>
          </HeaderCol>
          <HeaderCol sm={2}>
            <Text>Download</Text>
          </HeaderCol>
        </Header>

        <Alternating>
          {documents.map(item =>
            <Result
              href={item.document.file.sourceUrl}
              download
            >
              <Row alignItems="center">
                <Col sm={4}>
                  <Text style={{marginLeft: '1em'}}>{item.document.title}</Text>
                </Col>
                <Col sm={4}>
                  <Text>{item.document.documentType ? this.returnString(item.document.documentType, documentTypes) : ''}</Text>
                </Col>
                <Col sm={2}>
                  <Text>{item.document.language ? this.returnString(item.document.language, languages) : ''}</Text>
                </Col>
                <Col sm={2}>
                  <IconDownload />
                </Col>
              </Row>
            </Result>
          )}
        </Alternating>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/DocumentList/index.js